import { WindowsTopBar } from './bar/WindowsTopBar'
import { WindowsTopGlass } from './glass/WindowsTopGlass'
import { WindowsTopBarOuter } from './bar/WindowsTopBarOuter'
import { useMontage } from '../../../../../context/montage.context'

export const WindowsTop = (): JSX.Element => {
  const { measure } = useMontage()
  
  return (
    <group position={[0, measure.angleCompensation!, 0]}>
      {[...Array(measure.windowsTopTotal)].map((_, index) => {
        return (
          <group key={index}>
            <group>
              <WindowsTopBar positionX={index} />
              <WindowsTopGlass positionX={index} />
            </group>
            <WindowsTopBarOuter />
          </group>
        )
      })}
    </group>
  )
}
